// contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../firebase/firebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { checkUserStatus } from "../firebase/userService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);       // Firebase user
  const [userExt, setUserExt] = useState(null); // Firestore user data
  const [userStatus, setUserStatus] = useState({ isValid: true, error: null }); // blocked, deleted, etc
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      setUserExt(null);
      setUserStatus({ isValid: true, error: null });
      if (firebaseUser) {
        const status = await checkUserStatus(firebaseUser.uid);
        setUserExt(status.userData || null);
        setUserStatus({ isValid: status.isValid, error: status.error });

        // Nếu user bị khoá hoặc xoá → tự động logout
        if (!status.isValid) {
          await signOut(auth);
        }
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const updateUserExt = (data) => setUserExt((prev) => ({ ...prev, ...data }));

  return (
    <AuthContext.Provider value={{ user, currentUser:user,  userExt, userStatus, loading, updateUserExt }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
